import React from "react";
import "./ContactUs1.css";
import { useAlert } from "react-alert";

function ContactUs1() {
  const alert = useAlert();

  const formSubmit = (e) => {
    e.preventDefault();

    if (!e.target.fname.value) {
      alert.error("Please Enter Your First Name");
    } else if (!e.target.lname.value) {
      alert.error("Please Enter Your Last Name");
    } else if (!e.target.email.value) {
      alert.error("Please Enter Your E Mail");
    } else if (!e.target.phone.value) {
      alert.error("Please Enter Your Phone Number");
    } else {
      // emailjs
      //   .sendForm(
      //     "service_50yvekn",
      //     "template_jiqlvd9",
      //     e.target,
      //     "vxj6k5OSSzt9nYPbs"
      //   )
      //   .then((e) => {
      //     alert.success(
      //       "Thanks For Your Response We will Reply you as soon as possible"
      //     );
      //   });
      alert.success(
        "Thanks For Your Response We will Reply you as soon as possible"
      );
    }
  };

  return (
    <div>
      <div className="container-fluid main-contact-div1">
        {/* <svg
          className="contact-vector1 d-sm-block d-none"
          width="65"
          height="201"
          viewBox="0 0 65 201"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M103.476 0.0623773C144.217 1.51047 171.061 37.8544 183.39 76.877C195.394 114.872 192.755 158.559 161.184 182.719C127.602 208.417 81.0343 206.104 46.6254 181.535C11.0388 156.125 -9.07933 112.331 4.02486 70.5016C17.4843 27.5381 58.656 -1.53073 103.476 0.0623773Z"
            fill="#FFB532"
          />
        </svg> */}

        <div className="container main-contact-div2">
          <h1 className=" contactus-text1 ">
            Get In Touch With <span>US</span>.
          </h1>
          <div className="contactus-btn-div">
            <a href="tel:+44 01204 840303">
            <div className="contact-btn1">
              <p className="contactus-text2 text-center">+44 01204 840303</p>
            </div>
            </a>
            <a href="mailto:info@ajhaccountant.co.uk">
            <div className="contact-btn2">
              <p className="contactus-text2">info@ajhaccountant.co.uk</p>
            </div>
            </a>
          </div>

          <div>
            <form className="contact-form" onSubmit={formSubmit}>
              <div class="row">
                <div class="col-lg-6 col-12 ">
                  <input
                    type="text"
                    name="fname"
                    class="form-control contact-input-field2"
                    placeholder="First Name"
                  />
                </div>
                <div class="col-lg-6 col-12 mt-4 mt-lg-0">
                  <input
                    type="text"
                    name="lname"
                    class="form-control contact-input-field2"
                    placeholder="Last Name"
                  />
                </div>
                <div class=" col-12 mt-4">
                  <input
                    type="email"
                    name="email"
                    class="form-control contact-input-field2"
                    placeholder="E-Mail"
                  />
                </div>
                <div class="col-12 mt-4">
                  <input
                    type="number"
                    name="phone"
                    class="form-control contact-input-field2"
                    placeholder="Phone Number"
                  />
                </div>

                <div className="col-12 mt-4 contact-us-btn-div2">
                  <button
                    type="submit"
                    className="ml-sm-auto mx-sm-0 mx-auto contactus-form-btn4 mb-4"
                  >
                    Submit
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div className="mb-5">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d37888.11501922078!2d-2.5194968214412152!3d53.59333336388342!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x487b09d79ecf4d55%3A0xc81f309383c2481e!2sChorley%20Old%20Rd%2C%20Bolton%2C%20UK!5e0!3m2!1sen!2s!4v1669028544366!5m2!1sen!2s"
          className="contact-map"
          height="700"
          style={{ border: 0 }}
          referrerpolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
    </div>
  );
}

export default ContactUs1;
